<template>
    <div class="modal-footer p-0">
        <div class="btn-group no-arrow dropup dropup-center" v-if="model.id">
            <basic-button
                class="btn-secondary dropdown-toggle"
                icon="fi-rr-trash"
                :text="trans('general.defaults.delete')"
                data-bs-toggle="dropdown" aria-expanded="false"/>

            <ul class="dropdown-menu">
                <li>
                    <h6 class="dropdown-header">{{ trans('general.component.delete_popup.title') }}</h6>
                </li>
                <li>
                    <div v-on:click="deleteEvent(model.id)" class="dropdown-item text-danger" role="button">
                        {{ trans('general.component.delete_popup.yes') }}
                    </div>
                </li>
                <li>
                    <a class="btn btn-link dropdown-item text-success" href="#">
                        {{ trans('general.component.delete_popup.no') }}
                    </a>
                </li>
            </ul>
        </div>

        <basic-button
            class="btn-primary"
            :text="trans('general.defaults.save')"
            :disabled="$wait.is(submitPlanWaiter)"
            :loading="$wait.is(submitPlanWaiter)"
            v-on:click="submit"/>
    </div>
</template>

<script>
import {handleErrors} from "../../../services/ErrorHandler";
import BasicButton from "../../../theme/atoms/BasicButton.vue";
export const SUBMIT_PLAN_WAITER = 'submit-plan'

export default {
    name: "PlanFormFooter",
    props: {model: Object},
    components: {BasicButton},
    data() {
        return {
            errors: [],
        }
    },
    computed: {
        submitPlanWaiter() {
            return SUBMIT_PLAN_WAITER;
        }
    },
    methods: {
        submit(event) {
            this.$wait.start(SUBMIT_PLAN_WAITER)
            this.$emit('submit', event);
        },
        deleteEvent(id) {
            axios.delete(`/plans/${id || this.model.id}`)
                .then(response => {
                    this.$emit('event-deleted', response.data.data)
                })
                .catch(error => {
                    handleErrors(error, errors);
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                })
        },
    },
}
</script>
